export const CERTIFICADOPUSH = 'BEasI103dn6xHqkkbTKAYxhMWKI-eQ2JVOo3SDPGenBigCC5mnscyUmSHrtI9TZpaHBJEGJ917AL7_xFEoySGco'

export const URLAPI = 'https://mujeresempresariasunidas.com/noti/firebasepush.php'

export const IDPROYECTO = 'mujeresempersariasunidas'